import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown, Link as LinkIcon } from "lucide-react";
import { useSavedLinks, SavedLink } from "@/hooks/useSavedLinks";
import { useAuth } from "@/hooks/useAuth";

interface LinkInputWithDropdownProps {
  id?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  linkType: "linkedin" | "github" | "portfolio" | "project" | "other";
  className?: string;
}

export const LinkInputWithDropdown = ({
  id,
  placeholder,
  value,
  onChange,
  linkType,
  className,
}: LinkInputWithDropdownProps) => {
  const { user } = useAuth();
  const { getLinksByType } = useSavedLinks();
  
  const savedLinks = getLinksByType(linkType);
  const hasLinks = savedLinks.length > 0;

  const handleSelectLink = (link: SavedLink) => {
    onChange(link.url);
  };

  if (!user || !hasLinks) {
    return (
      <Input
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={className}
      />
    );
  }

  return (
    <div className="flex gap-1">
      <Input
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`flex-1 ${className || ""}`}
      />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" className="shrink-0" title="Use saved link">
            <ChevronDown className="w-4 h-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="z-[100] bg-background min-w-[200px]">
          <div className="px-2 py-1.5 text-xs font-medium text-muted-foreground">
            Saved {linkType} links
          </div>
          {savedLinks.map((link) => (
            <DropdownMenuItem
              key={link.id}
              onClick={() => handleSelectLink(link)}
              className="cursor-pointer"
            >
              <LinkIcon className="w-4 h-4 mr-2 text-muted-foreground" />
              <span className="truncate">{link.label}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
